import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

interface HeaderProps {
  isAdmin?: boolean;
  onLogout?: () => void;
}

const Header: React.FC<HeaderProps> = ({ isAdmin, onLogout }) => {
  return (
    <header className="header">
      <div className="header-container">
          <Link to="/" className="logo">
            <img src={process.env.PUBLIC_URL + '/transparent_logo.png'} alt="DcDetails Logo" className="header-logo-img" />
          </Link>

        <nav className="nav">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/services" className="nav-link">Services</Link>
          <Link to="/showcase" className="nav-link">Showcase</Link>
          <Link to="/book" className="nav-link booking-link">Book Now</Link>
          {isAdmin ? (
            <>
              <Link to="/admin" className="nav-link">Admin</Link>
              <button onClick={onLogout} className="nav-link logout-btn">
                Logout
              </button>
            </>
          ) : (
            <Link to="/admin/login" className="nav-link">Admin</Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;